import {
  tableColumnsWidth,
  key,
  slot,
  renderFn
} from '@/assets/js/resetTableStyle';
import store from '@/store';
export const platTypeMap = {
  1: store.state.projectName
};
export const discountTypeMap = {
  1: '节次减免券'
};

export const courseTypeMap = {
  1: '素质课',
  2: '基础托管'
};
export const receiveChannelMap = {
  1: '教务老师派券'
};
export const couponStsMap = {
  0: '未使用',
  1: '已使用',
  2: '已过期',
  3: '已失效'
};
export const columns = [
  {
    title: '优惠券名称',
    width: 210,
    slot: 'couponName',
    fixed: 'left'
  },
  {
    title: '优惠券适用平台',
    width: tableColumnsWidth.type3,
    key: 'platType',
    fixed: 'left',
    render: (h, params) => {
      return h('div', [platTypeMap[Number(params.row.platType)]]);
    },
    align: 'center'
  },
  {
    title: '优惠券类型',
    key: 'discountType',
    width: 120,
    fixed: 'left',
    render: (h, params) => {
      return h('div', [discountTypeMap[Number(params.row.discountType)]]);
    }
  },
  {
    title: '适用学校',
    width: tableColumnsWidth.type6,
    slot: 'schoolName'
  },
  {
    title: '学期',
    width: tableColumnsWidth.type4,
    key: 'yearTerm'
  },
  {
    title: '适用课程分类',
    key: 'courseType',
    width: tableColumnsWidth.type8,
    render: (h, params) => {
      return h('div', [courseTypeMap[Number(params.row.courseType)]]);
    },
    align: 'center'
  },
  {
    title: '适用课程数',
    slot: 'applicableCourseNumber',
    align: 'center',
    width: tableColumnsWidth.type8
  },
  {
    title: '发行总量',
    key: 'couponQty',
    width: tableColumnsWidth.type2,
    align: 'center'
  },
  {
    title: '剩余',
    key: 'remainingNumber',
    width: tableColumnsWidth.type2,
    align: 'center'
  },
  {
    title: '已作废',
    key: 'cancellationNumber',
    width: tableColumnsWidth.type2,
    align: 'center'
  },
  {
    title: '已发放',
    key: 'issuedNumber',
    width: tableColumnsWidth.type2,
    align: 'center'
  },
  {
    title: '已使用',
    key: 'hasBeenUsedNumber',
    width: tableColumnsWidth.type2,
    align: 'center'
  },
  {
    title: '已过期',
    key: 'expiredNumber',
    width: tableColumnsWidth.type2,
    align: 'center'
  },
  {
    title: '已失效',
    key: 'hasFailureNumber',
    width: tableColumnsWidth.type2,
    align: 'center'
  },
  {
    title: '待使用',
    key: 'toBeUsedNumber',
    width: tableColumnsWidth.type2,
    align: 'center'
  },
  {
    title: '优惠内容',
    slot: 'couponDesc',
    width: tableColumnsWidth.type5
  },
  {
    title: '有效日期',
    slot: 'effotTime',
    width: tableColumnsWidth.type4
  },
  {
    title: '状态',
    slot: 'couponSts',
    width: tableColumnsWidth.type2,
    align: 'center'
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: 190
  },
  {
    title: '更新时间',
    key: 'operateTime',
    width: 190
  },
  {
    title: '更新人',
    key: 'operatorName',
    width: 120
  },
  {
    title: '操作',
    slot: 'action',
    width: 150,
    align: 'center',
    fixed: 'right'
  }
];

export const columnsList = [
  {
    title: '优惠券编号',
    width: 210,
    key: 'relId',
    fixed: 'left'
  },
  {
    title: '优惠券名称',
    width: 210,
    slot: 'couponName',
    fixed: 'left'
  },
  {
    title: '优惠券状态',
    key: 'couponSts',
    width: 110,
    render: (h, params) => {
      return h('div', [couponStsMap[Number(params.row.couponSts)]]);
    },
    align: 'center'
  },
  {
    title: '学校',
    width: tableColumnsWidth.type6,
    slot: 'schoolName'
  },
  {
    title: '学期',
    width: tableColumnsWidth.type4,
    key: 'yearTerm'
  },
  {
    title: '年级班级',
    key: 'gradeClassName',
    width: 120
  },
  {
    title: '学生姓名',
    key: 'userName',
    width: 110
  },

  {
    title: '渠道',
    key: 'receiveChannel',
    width: 130,
    render: (h, params) => {
      return h('div', [receiveChannelMap[Number(params.row.receiveChannel)]]);
    }
  },

  {
    title: '发放时间',
    key: 'createTime',
    width: 190
  },
  {
    title: '操作人',
    key: 'creatorName',
    width: 120
  },
  {
    title: '优惠券有效日期',
    key: 'endTime',
    width: 190
  },

  {
    title: '使用课程',
    slot: 'courseList',
    minWidth: tableColumnsWidth.type6
  },

  {
    title: '操作',
    slot: 'action',
    width: 150,
    align: 'center',
    fixed: 'right'
  }
];
